module.exports = __webpack_public_path__ + "img/guidedogsaus.089dfe7.png";